import { IConfiguredHttp } from './http';

export interface IPropertyDescriptionApi {

	getPropertyDescription(propertyId: number): Promise<{ description: string }>;
}

const propertyDescriptionApiFactory = (http: IConfiguredHttp, prefix = ''): IPropertyDescriptionApi => ({
	getPropertyDescription(propertyId) {
		return http.get(`${prefix}/${propertyId}`);
	}
});

export default propertyDescriptionApiFactory;
